module.exports = __webpack_public_path__ + "assets/images/announcement-temperature-probe-sensor.png";